<template>
    <div>
        <sweet-modal title="Receive Report" blocking ref="purchaseProjectTaskOrder" class="modal" v-on:close="closePurchaseProjectTaskOrder">
            <!--<div style="display:flex; justify-content: center;">-->
                <!--<h2>Receive Report</h2>-->
            <!--</div>-->
            <el-form :model="form" size="mini" label-width="115px" ref="form" status-icon  class="demo-ruleForm">

                <el-table
                        :data="[form]"
                        style="width: 100%">
                    <el-table-column
                            label="No.">
                        <template slot-scope="scope">
                            {{scope.row.code}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="action === 'editProject'"
                            :label="labelName">
                        <template slot-scope="scope">
                            {{scope.row.project.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Task">
                        <template slot-scope="scope">
                            {{scope.row.task.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Vendor">
                        <template slot-scope="scope">
                            {{scope.row.vendor.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Order Date">
                        <template slot-scope="scope">
                            <div v-if="scope.row.date">
                                {{moment(scope.row.date.toString(), 'x').format('D MMM YY')}}
                            </div>
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--label="Current Credit">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{formatPrice(scope.row.vendorCredit)}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--label="Exchange Rate">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{scope.row.exchageRate}} USD = 1 {{scope.row.vendorCurrency}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column
                            label="Reference">
                        <template slot-scope="scope">
                            {{scope.row.reference}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Deliver To">
                        <template slot-scope="scope">
                            {{scope.row.deliverTo}}
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--label="Tax include">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{scope.row.ifTax}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--label="WHTax">-->
                        <!--<template slot-scope="scope">-->
                            <!--<div v-if="scope.row.isWth">-->
                                <!--Apply WHTax-->
                            <!--</div>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>

                <el-row :span="24" style="margin: 20px 0;">
                    Description
                    <div>
                        {{form.description}}
                    </div>
                </el-row>

                <!--TABLE START -->
                Items
                <el-table
                        size="mini"
                        border
                        :data="form.items"
                        style="width: 100%"
                        @cell-click="cellClick">
                    <el-table-column
                            label="No.">
                        <template slot-scope="scope">
                            {{scope.row.code}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Name">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--label="Unit Price">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{scope.row.amount}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column
                            label="Ordered">
                        <template slot-scope="scope">
                            {{scope.row.qty}}
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--label="VAT exclusive">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{formatPrice(scope.row.vatExclusive)}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--label="Tax">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{scope.row.tax.name}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--label="Unit"-->
                            <!--width="80">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{scope.row.unit.name}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--label="WHTax"-->
                            <!--width="100px">-->
                        <!--<template slot-scope="scope">-->
                            <!--<div v-if="scope.row.withholdingTax">-->
                                <!--{{scope.row.withholdingTax.name}}-->
                            <!--</div>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column
                            label="Required Delivery date">
                        <template slot-scope="scope">
                            {{moment(scope.row.date, 'x').format('DD MMM YYYY')}}
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--label="Total">-->
                        <!--<template slot-scope="scope">-->
                            <!--{{formatPrice(scope.row.total)}}-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column
                            label="Backorder">
                        <template slot-scope="scope">
                            <div v-if="scope.row.newBackorder || scope.row.newBackorder === 0">
                                {{scope.row.newBackorder}}
                            </div>
                            <div v-else >
                                {{scope.row.backorder}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Received"
                            width="150px">
                        <template slot-scope="scope">
                            <el-form-item size="mini"
                                          label-width="0"
                                          :prop="'items.' + scope.$index + '.received'"
                                          :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                <el-input-number size="mini" v-model="scope.row.received" :disabled="scope.row.isClosed" controls-position="right" @change="countBackOrder(scope)" :min="0" :max="scope.row.backorder"></el-input-number>
                                <!--<el-input @change="countBackOrder(scope)" type="number" v-model="scope.row.received" size="mini"></el-input>-->
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Closed">
                        <template slot-scope="scope">
                            <el-form-item label-width="0">
                                <el-checkbox v-model="scope.row.closed" :disabled="scope.row.isClosed" size="mini"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
                <!--TABLE END -->
                <el-row :span="24" style="display:flex; justify-content: flex-end">
                    <el-col :span="12">
                        <el-form-item style="margin-bottom:0; margin-top:20px;">
                            <el-checkbox disabled v-model="form.allowPartialDeliveries" label="Allow Partial Deliveries"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox disabled v-model="form.sendInventoryWithBill" label="Send Inventory with Bill"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox disabled v-model="form.sendInventoryWithoutBill" label="Send Inventory without Bill"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            Internal
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox disabled v-model="form.receiveReportRequired" label="Receive Report Required"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox disabled v-model="form.inspectionReportRequired" label="Inspection Report Required"></el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <div class="bill">
                            <el-form-item prop="dateReceived" label="Date Received">
                                <el-date-picker
                                        v-model="form.dateReceived"
                                        format="d MMM yy"
                                        value-format="timestamp"
                                        type="date"
                                        placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item  v-if="user.user" label="Received By" prop="receivedBy" style="text-align:left;">
                                {{form.receivedBy = user.user.firstname + ' ' + user.user.lastname}}
                                <!--<el-input placeholder="Received By" v-model="form.receivedBy"></el-input>-->
                            </el-form-item>
                            <el-form-item label="Freight Company" prop="freightCompany">
                                <el-input placeholder="Freight Company" v-model="form.freightCompany"></el-input>
                            </el-form-item>
                            <!--<h4 v-if="form.ifTax === 'Tax Exclusive'"><span>Subtotal</span><span> {{formatPrice(form.subTotal)}} </span></h4>-->
                            <!--<h4 v-if="form.ifTax === 'Tax Exclusive'"><span>+ Tax of</span><span>{{formatPrice(form.taxOf)}}</span></h4>-->
                            <!--<h4 v-if="form.ifTax === 'Tax Inclusive'"><span>Includes Tax of</span><span>{{ formatPrice(form.includesTaxOf)}} </span></h4>-->
                            <!--<h4><span>Total Amount</span><span> {{formatPrice(form.totalAmount)}} </span> </h4>-->
                            <!--<h4 v-if="form.isWth"><span>WHTax Amount</span><span>{{formatPrice(form.whtTaxAmount) }}</span></h4>-->
                            <!--<el-divider></el-divider>-->
                            <!--<div class="payment-to-vendor">-->
                                <!--<h3><span>Payment to Vendor</span><span>{{formatPrice(form.paymentToVendor)}}</span></h3>-->
                            <!--</div>-->
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                        <div v-if="file" class="file">
                            <el-row>
                                <el-col :span="20">
                                    <div>{{file.name}}</div>
                                </el-col>
                                <el-col :span="4" style="display:flex; justify-content: flex-end">
                                    <el-button @click="viewFile(file.url)" type="warning" icon="el-icon-view" size="mini" plain></el-button>
                                    <el-button @click="removeFileEdit(file.url)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                </el-col>
                            </el-row>
                        </div>
                </el-row>

                <el-form-item  style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-upload
                            v-if="form.sendInventoryWithBill"
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                    >
                        <el-button type="primary" plain size="medium">Add Bill</el-button>
                    </el-upload>
                    <el-button @click="purchaseUpdate('form', activePurchaseId)" class="modal__btn" type="primary" plain size="medium">Receive</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import Media from '@dongido/vue-viaudio'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "purchaseOrderInfoModal",
    components:{
      SweetModal,

      Media,
    },
    computed:{
      user() {
        return this.$store.state.user
      }
    },
    data() {
      return{
        moment:moment,
        action: 'editProject',
        labelName: 'Project',
        state: 'project',
        activePurchaseId: '',
        // FILES
        file: false,
        fileUrl: '',
        fileId: null,
        type: '',
        viewerType: '',
        // FORM
        form:{
          project: {},
          task: {},
          vendor: {},
          date: null,
          vendorCurrency: "GBP",
          vendorCredit: '0',
          exchageRate: null,
          reference: null,
          deliverTo: null,
          description: null,
          itemsId:[],
          ifTax: 'Tax Inclusive',
          isWth: false,
          items:[],
          dateReceived: null,
          receivedBy: null,
          freightCompany: null,
          //bill
          subTotal: '0',
          taxOf: '0',
          totalAmount:'0',
          includesTaxOf: '0',
          whtTaxAmount: '0',
          paymentToVendor: '0'
        }
      }
    },
    methods:{
      // open modal purchases
      async openModalUpdate(companyId, projectId, projectTaskId, purchaseId, state, manager){
        this.activePurchaseId = purchaseId
        console.log('companyId, projectId, projectTaskId, purchaseId, state, manager', companyId, projectId, projectTaskId, purchaseId, state, manager)
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state

          //Get project list
          // this.projectList = await this.getProjectList(urlParts.routeName)

          //Get task list
          // if(projectId){
            this.action = 'editProject'

            //Get purchase item if project
            await this.getPurchaseItem(state, purchaseId)
          // }else{
          //   this.action = 'editTask'
          //
          //   //Get purchase item if task
          //   await this.getPurchaseItem(urlParts.stateTask, purchaseId)
          // }

          this.$refs.purchaseProjectTaskOrder.open()

        }catch (err){
          console.log(err)
        }
      },
      getPurchaseItem(type, purchaseId){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/purchaseOrder/item?type=${type}&id=${purchaseId}`)
            .then(response => {
                this.form.code = response.data.item.purchaseOrder.code,
                this.form.vendor = response.data.item.purchaseOrder.vendor,
                this.form.date = response.data.item.purchaseOrder.orderDate,
                this.form.vendorCurrency = response.data.item.purchaseOrder.vendorCurrency,
                this.form.vendorCredit = response.data.item.purchaseOrder.vendorCredit,
                this.form.exchageRate = response.data.item.purchaseOrder.exchageRate,
                this.form.reference = response.data.item.purchaseOrder.reference,
                this.form.deliverTo = response.data.item.purchaseOrder.deliverTo,
                this.form.itemsId = response.data.item.purchaseOrder.items.map(item => item.id)
                this.form.ifTax = response.data.item.purchaseOrder.includeTax ? 'Tax Exclusive' : 'Tax Inclusive',
                this.form.isWth = response.data.item.purchaseOrder.inludeWth,
                this.form.description = response.data.item.purchaseOrder.description,
                this.fileId = response.data.item.purchaseOrder.fileId,
                //bill
                this.form.subTotal = response.data.item.purchaseOrder.subTotal,
                this.form.taxOf = response.data.item.purchaseOrder.taxOf,
                this.form.totalAmount = response.data.item.purchaseOrder.totalAmount,
                this.form.includesTaxOf = response.data.item.purchaseOrder.includeTax,
                this.form.whtTaxAmount = response.data.item.purchaseOrder.whtTaxAmount,
                this.form.paymentToVendor = response.data.item.purchaseOrder.paymentToVendor
                //checkboxes
                this.form.allowPartialDeliveries = response.data.item.purchaseOrder.allowPartialDeliveries
                this.form.sendInventoryWithBill = response.data.item.purchaseOrder.sendInventoryWithBill
                this.form.sendInventoryWithoutBill = response.data.item.purchaseOrder.sendInventoryWithoutBill
                this.form.receiveReportRequired = response.data.item.purchaseOrder.receiveReportRequired
                this.form.inspectionReportRequired = response.data.item.purchaseOrder.inspectionReportRequired
              switch(type){
                case 'project':
                  this.form.project = response.data.item.project
                  break;
                case 'projectTask':
                  this.form.task = response.data.item.projectTask
                  break;
                case 'engagement':
                  this.form.project = response.data.item.engagament
                  break;
                case 'engagementTask':
                  this.form.task = response.data.item.engagamentTask
                  break;
                case 'businessUnit':
                  this.form.project = response.data.item.businessUnit
                  break;
                case 'businessUnitTask':
                  this.form.task = response.data.item.businessUnitTask
                  break;
              }

              // create item list
              // const items = []
              // response.data.item.purchaseOrder.items.forEach(val => {
              //   const item = {
              //     id: val.id,
              //     originalItemId: val.originalItemId,
              //     code: val.code,
              //     name: val.name,
              //     tax: val.tax,
              //     unit: val.unit,
              //     wtx: val.withholdingTax,
              //     amount: val.amount,
              //     taxId: val.taxId,
              //     itemWhTaxName: val.withholdingTax ? val.withholdingTax.name : null,
              //     qty: val.qty,
              //     date: val.date * 1000,
              //     vatExclusive: val.vatExclusive,
              //     total: val.total,
              //   }
              //   items.push(item)
              // })

              const newItems = response.data.item.purchaseOrder.items.map(function(item) {
                item.wtx = item.withholdingTax
                item.closed = item.closed === 1
                item.isClosed = item.closed
                item.received = 0
                return item
              });

              this.form.items = newItems
              if (response.data.item.purchaseOrder.file !== null) {
                this.file = response.data.item.purchaseOrder.file
                this.file.name = response.data.item.purchaseOrder.file.baseName
              }
              resolve(response.data.item)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      countBackOrder(scope){
        console.log('scope', scope)
        scope.row.newBackorder = Number(scope.row.backorder) - Number(scope.row.received)
        if (!scope.row.newBackorder) {
            scope.row.closed = true
        }else{
          scope.row.closed = false
        }
      },
      handleAvatarSuccess( file, fileList ) {
        console.log("FILE",file);
        console.log('---', this.fileUrl);
        var formData = new FormData();
        formData.append('file', file.file);
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            const newFileItem = {
              id: '',
              name: '',
              url: ''
            }
            newFileItem.name = file.file.name
            newFileItem.id = response.data.fileId
            newFileItem.url = response.data.fileUrl
            console.log('newFileItem', newFileItem)
            this.file = newFileItem
            this.fileUrl = response.data.fileUrl
            this.fileId = response.data.fileId

            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
          this.$message.error('Avatar picture size can not exceed 2MB!');
        }
        return isLt2M;
      },
      viewFile(url) {
        this.fileUrl = url
        this.type = this.fileUrl.split('.').pop().toUpperCase()
        console.log('---', this.fileUrl, this.type);

        if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
          this.viewerType = 2;
          setTimeout(() => {
            console.log('-----', this.$el);
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
          }, 300);
        } else if (this.type == 'AVI' || this.type == 'MP4' || this.type == 'MOV') {
          this.viewerType = 3;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
          this.viewerType = 4;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else {
          this.viewerType = 1;
          setTimeout(() => {
            this.nestedChildOpen(url)
          }, 300);
        }
      },
      nestedChildOpen(url){
        this.fileUrl = url
        this.$refs.nestedChild.open();
      },
      purchaseUpdate(form, id){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const urlParts = this.buildUrl(this.state)
            if(this.form.items.length === 0) {
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

            if(this.form.sendInventoryWithBill && !this.file){
              return this.$message({
                type: 'error',
                message: 'Add Bill'
              })
            }



            const data = {
              vendorId: this.form.vendorId,
              orderDate: this.form.date,
              vendorCurrency: this.form.vendorCurrency,
              vendorCredit: this.form.vendorCredit,
              exchageRate: Number(this.form.exchageRate),
              reference: this.form.reference,
              deliverTo: this.form.deliverTo,
              includeTax: this.form.ifTax === 'Tax Exclusive',
              inludeWth: this.form.isWth,
              description: this.form.description,
              //bill
              subTotal: this.form.ifTax === 'Tax Exclusive' ? this.form.subTotal : null,
              taxOf: this.form.ifTax === 'Tax Exclusive' ? this.form.taxOf : null,
              totalAmount: this.form.totalAmount,
              includesTaxOf: this.form.ifTax === 'Tax Inclusive' ? this.form.includesTaxOf : null,
              whtTaxAmount: this.form.isWth ? this.form.whtTaxAmount : null,
              paymentToVendor: this.form.paymentToVendor,
              fileId: this.fileId,
              dateReceived: this.form.dateReceived,
              receivedBy: this.form.receivedBy,
              freightCompany: this.form.freightCompany,
            };

            for(let i = 0; i < this.form.items.length; i ++){
            console.log('this.form.items', this.form.items)
              if(this.form.items[i].newBackorder && this.form.items[i].newBackorder !== 0 && !this.form.allowPartialDeliveries){
                  if(this.form.items[i].newBackorder !== this.form.items[i].qty){
                    console.log('this.form.items[i].newBackorder', this.form.items[i].newBackorder)
                    return this.$message({
                      type: 'error',
                      message: 'Partial Deliveries disabled'
                    })
                  }
                }
            }

            const items = []
            let sumReceived = 0
            this.form.items.forEach(val => {
              sumReceived = sumReceived + val.received
              // console.log('val.wtx ? val.wtx.id', val)
              // console.log('val.newBackorder', val.newBackorder )
              // console.log('this.form.allowPartialDeliveries', this.form.allowPartialDeliveries )
              const item = {
                change: val.received !== 0,
                id: val.id,
                code: val.code,
                name: val.name,
                amount: val.amount,
                unitId: val.unit.id,
                received: val.received,
                taxId: val.taxId,
                closed: val.closed ? 1 : 0,
                backorder: val.newBackorder,
                itemWhTaxId: val.wtx ? val.wtx.id : null,
                qty: val.qty,
                date: val.date,
                vatExclusive: val.vatExclusive,
                total: val.total,
              };
              items.push(item)
            })


            data.items = items;

            //check if items received
            if(!sumReceived){
              return this.$message({
                type: 'error',
                message: 'Receive items'
              })
            }

            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/purchaseOrder/update?id=${id}`, data)
                .then(response => {
                  this.notification("Success", "Request Updated", "success");
                  if(this.$route.name === 'projects' && this.state === 'project' || this.$route.name === 'business-units' && this.state === 'business-unit' || this.$route.name === 'engagements' && this.state === 'engagement') {
                    this.$emit('refreshPurchase')
                  }else if (this.$route.name === 'purchases'){
                    this.$emit('setValueProject', this.form.projectListId);
                  }
                  this.$refs.purchaseProjectTaskOrder.close()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  reject(error)
                });
            })
          }
        })
      },
      removeFileEdit: function (url) {
        this.$emit('removeFile', url);
        this.file = false
      },
      closePurchaseProjectTaskOrder(){
        this.fileUrl = '';
        this.fileId = null;
        this.file = false;
        this.form.vendor = {};
        this.form.task = {};
        this.form.project = {};
        this.form.date = '';
        this.form.vendorCurrency = '';
        this.form.vendorCredit = '';
        this.form.exchageRate = '';
        this.form.reference = '';
        this.form.deliverTo = '';
        this.form.itemsId = '';
        this.form.ifTax = '';
        this.form.isWth = '';
        this.form.description = '';
        //bill
        this.form.subTotal = '0';
        this.form.taxOf = '0';
        this.form.totalAmount = '0';
        this.form.includesTaxOf = '0';
        this.form.whtTaxAmount = '0';
        this.form.paymentToVendor = '0';
        this.form.dateReceived = null;
        this.form.receivedBy = null;
        this.form.freightCompany = null;
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClick(row, column, event){
        console.log('row', row);
        console.log('column', column)
      },
      buildUrl(state) {
        let routeName = '';
        let labelName = '';
        let stateProjectId = '';
        let projectId = '';
        let stateTaskId = '';
        let taskId = '';
        let stateExpenseId = '';
        let stateProjectTasks = '';
        let stateTask = '';
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskPurchaseId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskPurchaseId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskPurchaseId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    .bill{
        margin-top:25px;
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
    /deep/ .avatar-uploader .el-upload {
        border: none;
    }
    .iframe{
        width:100%;
        height:700px;
    }
</style>
